import Environment from '../modules/Environment';
import AuthUtils from '../modules/AuthUtils';
import TokenRefreshManager from '../modules/TokenRefreshManager';
import store from '../store';
import { REGISTER_AUTH_TOKEN, } from '../actions/auth';

const AuthenticationService = (() => {
  const service = {};
  const BASE_URL = Environment.getBaseURL();

  service.login = (credentials = {}) => {
    const { username, password, } = credentials;

    return fetch(`${BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password, }),
    });
  };

  service.isAuthenticated = () => {
    const { auth = {}, } = store.getState();
    const { authentication = {}, } = auth;
    return !!authentication.token && AuthUtils.isTokenValid(authentication.token);
  };

  /**
   * Whether a session exists at all, regardless of whether its token has expired.
   * An expired token is recoverable via the lock screen, so callers that guard
   * navigation should use this rather than isAuthenticated() — otherwise an expiry
   * tears down the page the lock screen is meant to overlay.
   */
  service.hasSession = () => {
    const { auth = {}, } = store.getState();
    const { authentication = {}, } = auth;
    return !!authentication.token;
  };

  service.logout = async () => {
    // Stop token refresh manager
    TokenRefreshManager.stop();

    // Call backend to clear HttpOnly cookie
    try {
      await fetch(`${BASE_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
      // Continue with client-side logout even if backend call fails
    }

    store.dispatch({ type: REGISTER_AUTH_TOKEN, data: {}, });
    window.localStorage.removeItem('PAYIT_TOKEN');

    // Redirect to login page
    if (window.location.hash !== '#/') {
      window.location.hash = '#/';
    }
  };

  return service;
})();

export default AuthenticationService;
